module.exports = __webpack_public_path__ + "media/images/tl/banner/id-dark-16e3519ea5c6ed248bd54b1797ad03a7.jpg";